import { DatasetDetailsModal as SharedDatasetDetailsModal } from '@verantos-dev/ui-cohort-builder-components';

import { useProjectModalContext } from '../../context/modalContext';

export const DatasetDetailsModal = ({
  releaseId,
  releaseName,
}: {
  releaseId: string;
  releaseName: string;
}) => {
  const { closeDialog } = useProjectModalContext();

  return (
    <SharedDatasetDetailsModal
      releaseId={releaseId}
      releaseName={releaseName}
      onClose={closeDialog}
    />
  );
};
